import Base from 'netxcore@netx/core-app/views/appModalView';

import {faTimes} from '@netx/core-icons';
const icons = Base.initializeIcons({
	faTimes,
});

export default class AppModalView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};

		opts.events = _.extend(
			{
				keydown: 'closeOnEscape',
			},
			opts.events,
		);

		super(opts);
	}

	closeOnEscape(e) {
		const code = e.which;
		if (code === 27) {
			this.close();
		}
	}
}
